// Écran d'authentification partagé (mise en page en deux colonnes).
// Colonne gauche : formulaire ; colonne droite : visuel océan polynésien.
import React from "react";

const IMAGE_AUTH =
  "https://images.unsplash.com/photo-1653153975552-7297e8fe1b36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&h=1800&fit=crop";

export function AuthLayout({ titre, sousTitre, children }) {
  return (
    <div className="min-h-screen flex bg-[#E8F4F4]">
      {/* Colonne formulaire */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center px-6 sm:px-12 lg:px-20 py-12">
        <div className="w-full max-w-md mx-auto fenua-fade-up">
          <div className="mb-10">
            <span
              data-testid="logo-marque"
              className="text-2xl font-black tracking-tight text-[#1D3D3D]"
            >
              Porinetia Compta <span className="text-[#4A8A8A]">AERH</span>
            </span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-black tracking-tight text-[#1D3D3D]">
            {titre}
          </h1>
          {sousTitre && (
            <p className="mt-2 text-[#1D3D3D]/70 text-sm">{sousTitre}</p>
          )}
          <div className="mt-8">{children}</div>
        </div>
      </div>

      {/* Colonne visuelle */}
      <div className="hidden lg:block lg:w-1/2 relative overflow-hidden">
        <img
          src={IMAGE_AUTH}
          alt="Vallée montagneuse verdoyante de Tahiti, Polynésie française"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#1D3D3D]/85 via-[#2D5A5A]/55 to-transparent" />
        <div className="absolute bottom-0 left-0 p-12 text-white max-w-lg">
          <h2 className="text-3xl font-black tracking-tight leading-tight">
            La comptabilité simplifiée pour la Polynésie française
          </h2>
          <p className="mt-4 text-white/85 text-base">
            Conçu pour les TPE et PME du fenua. Gérez vos documents et vos
            obligations en toute sérénité.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
